import roles from "helpers/roles";
import { encryptToken } from "./authenticationCrypto";

// Keep in sync with keys written in setStorage, setMeStorage, and api.js refresh logic
const AUTH_KEYS = [
	"me",
	"token",
	"originalLogin",
	"loginType",
	"clientAdminMode",
	"clientUserId",
	"settingType",
	// Locale state is per-user/per-session: drop it on logout so the login page
	// is English and the next sign-in re-resolves the effective locale cleanly.
	"appLocale",
	"localeResolvedSiteApp",
];

export function clearAuthStorage() {
	AUTH_KEYS.forEach((key) => {
		sessionStorage.removeItem(key);
		localStorage.removeItem(key);
	});
}

export function setMeStorage(data) {
	return new Promise((res) => {
		const modifiedData = {
			...data,
			jwtToken: encryptToken(data.jwtToken),
			refreshToken: encryptToken(data.refreshToken),
		};
		localStorage.setItem("me", JSON.stringify(modifiedData));
		sessionStorage.setItem("me", JSON.stringify(modifiedData));
		res(data);
	});
}

export function setStorage(res) {
	return new Promise(async (resolve) => {
		localStorage.setItem("token", encryptToken(res.jwtToken));
		sessionStorage.setItem("token", encryptToken(res.jwtToken));
		let response = res;
		if (response.position !== null) {
			response["role"] = roles.siteUser;
		}
		await setMeStorage(response);

		resolve(response);
	});
}
